import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {
    retrieveFields({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("field/retrieveFields").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldsBySearch({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("field/retrieveFieldsBySearch" , filter)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("field/retrieveFieldById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveField({ commit }, field) {
        commit("SET_LOADING", true);
        return postAPI("field/saveField", field).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteField({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("field/deleteField/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteFieldLot({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("field/deleteFieldLot/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countFields({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("field/count").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };